import { fetchComputedInventoryForModificationDebounce } from 'models/kiosks/helpers';

import { kioskInventoryRouteStore } from '../domain/store';

export default (e) => {
  kioskInventoryRouteStore.setValue('drugFilter', e.target.value);
  return fetchComputedInventoryForModificationDebounce();
};
